import orgs from '@/API/services/orgs';
import miniToastr from 'mini-toastr';
import dayjs from 'dayjs';
import router from '@/router/';

export default {
  state: {
    orgs: [],
    currentOrganisation: {},
    packages: [],
    countries: [],
    statuses: [],
    organisationDashboard: null,
    interfacesDashboard: null,
    organisationDashboardDates: {},
  },
  mutations: {
    SET_ORG: (state, payload) => {
      if(payload && payload.data) {
        state.orgs = payload.data;
      }
    },
    SET_ORGANISATION_DASHBOARD_DATES: (state, payload) => {
      state.organisationDashboardDates = payload;
    },
    CREATE_ORGANISATION: (state, payload) => {
      state.orgs.push(payload.organisation);
      router.push(
        `/organisation-dashboard?f=${payload.timeStart}&t=${payload.timeEnd}&org=${payload.organisation.clientHash}`
      )
    },
    EDIT_ORGANISATION: (state, payload) => {
      state.orgs.forEach(organisation => {
        organisation.ID === payload.ID ? organisation = payload : false;
      });
    },
    SET_CURRENT_ORGANISATION: (state, payload) => {
      state.currentOrganisation = payload;
    },
    SET_PACKAGES: (state, payload) => {
      state.packages = payload;
    },
    SET_COUNTRIES: (state, payload) => {
      state.countries = payload;
    },
    SET_ORG_STATUSES: (state, payload) => {
      state.statuses = payload;
    },
    SET_ORGANISATION_DASHBOARD: (state, payload) => {
      if(payload && payload[0]) {
        state.organisationDashboard = {
          ...payload[0],
          backupApps: payload[0].apps,
        }
      }
    },
    SET_INTERFACES_DASHBOARD: (state, payload) => {
      let mappedArray = [];

      payload.forEach(item => {
        const key = Object.keys(item);

        item[key].chartdata.labels = item[key].chartdata.labels.map(item => {
          let formattedDate = dayjs.unix(item);
          return dayjs(formattedDate).format('DD/MM/YYYY');
        });

        mappedArray.push(item[key]);
      });

      state.interfacesDashboard = mappedArray;
    },
    FILTER_APPS: (state, payload) => {
      const app = state.organisationDashboard.backupApps.filter(app => app.id === payload);
      const backupApps = state.organisationDashboard.backupApps;
      payload !== '*' ? state.organisationDashboard.apps = app : state.organisationDashboard.apps = backupApps;
    },
  },
  getters: {
    organisationDashboardDates: (state) => {
      return state.organisationDashboardDates;
    },
    userClientHashList: (state) => {
      // return just the list of clienthashes
      return state.orgs.map(org => {
        return org.ID
      }).join(',')
    }
  },
  actions: {
    setOrganisationDashboardDates: ({ commit }, payload) => {
      commit('SET_ORGANISATION_DASHBOARD_DATES', payload);
    },
    saveOrganisation: async ({ commit }, payload) => {
      try {
        const response = await orgs.saveOrganisation(payload);
        commit('SAVE_ORG', response);
      } catch (err) {
        console.log(err);
      }
    },
    fetchOrganisations: async ({ commit }, payload) => {
      try {
        commit('SET_ORG', {})
        const response = await orgs.fetchOrganisations(payload);
        commit('SET_ORG', response);
        return response.data;
      } catch (err) {
        console.log(err);
      }
    },
    fetchSingleOrganisation: async ({ commit }, payload) => {
      try {
        if(payload) {
          const { data } = await orgs.getOne(payload);
          commit('SET_CURRENT_ORGANISATION', data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    fetchPackages: async ({ commit }) => {
      try {
        const [countries] = await Promise.all([
          orgs.getCountries(),
        ]);
        commit('SET_COUNTRIES', countries.data);
      } catch (err) {
        console.log(err);
      }
    },
    fetchCountries: async ({ commit }) => {
      try {
        const [countries] = await Promise.all([
          orgs.getCountries(),
        ]);
        commit('SET_COUNTRIES', countries.data);
      } catch (err) {
        console.log(err);
      }
    },
    getOrganisationData: async ({ commit }, payload) => {
      try {
        const { data } = await orgs.getOrganisationDashboard(payload);
        commit('SET_ORGANISATION_DASHBOARD', data);
      } catch (err) {
        console.log(err);
      }
    },
    getInterfacesData: async ({ commit }, payload) => {
      try {
        const { data } = await orgs.getInterfacesDashboard(payload);
        commit('SET_INTERFACES_DASHBOARD', data);
      } catch (err) {
        console.log(err);
      }
    },
    createOrganisation: async ({ commit, dispatch  }, payload) => {
      try {
        dispatch('togglePreloader', true);
        const ret = await orgs.createOrganisation(payload.organisation);
        commit('CREATE_ORGANISATION', payload);
        console.log('new org:', ret.data);
        commit('ADD_UCLIENT', {ID: ret.data, admin:true, build:true});
        // miniToastr.success('You have added new organisation!', ' ');
        return { status: 'success', text: 'You have added new organisation!' };
      } catch (err) {
        console.log(err);
      } finally {
        dispatch('togglePreloader', false);
      }
    },
    editOrganisation: async ({ commit, dispatch }, payload) => {
      try {
        dispatch('togglePreloader', true);
        await orgs.editOrganisation(payload.organisation);
        commit('EDIT_ORGANISATION', payload);
        miniToastr.success('You have edited organisation!', ' ');
      } catch (err) {
        console.log(err);
      } finally {
        dispatch('togglePreloader', false);
      }
    },
    filterByApp: ({ commit }, payload) => {
      commit('FILTER_APPS', payload);
    }
  },
};
